import BeachAccessIcon from "@mui/icons-material/BeachAccess"
import { Box, Typography } from "@mui/material"
import { makeStyles } from "tss-react/mui-compat"
import useCurrent from "lib/use-current"
import React from "react"

const useStyles = makeStyles()(
  (theme) => ({
    container: {
      display: "flex",
      alignItems: "center",
      flexFlow: "column nowrap",

      width: "100%",
      paddingTop: 20,
    },
    typography: {
      ...theme.fonts.lato400,
      fontSize: 16,
      lineHeight: 1.375,
    },
    cookiesContainer: {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",

      marginTop: 16,
      fontSize: 21.5,

      "& > *": {
        margin: theme.spacing(1),
      },

      "& > :nth-child(1)": {
        color: theme.palette.primary.main,
      },
      "& > :nth-child(2)": {
        color: theme.palette.primary.light,
      },
      "& > :nth-child(3)": {
        color: theme.palette.primary.lighter,
      },
    },
  })
)

interface ConventionCuratorHasNoFallbackProps {
  /*
   * @description Text fallback - {curatorName} has no {hasNo} just yet.
   * */
  hasNo: string
}

export const ConventionCuratorHasNoFallback = (props: ConventionCuratorHasNoFallbackProps) => {
  const { hasNo } = props
  const { classes } = useStyles()

  const current = useCurrent()

  const curatorName = current?.config?.provider_name

  return (
    <Box className={classes.container}>
      <Typography className={classes.typography} component="p">
        {curatorName} has no {hasNo} just yet.
      </Typography>
      <Box className={classes.cookiesContainer}>
        <BeachAccessIcon />
        <BeachAccessIcon />
        <BeachAccessIcon />
      </Box>
    </Box>
  )
}
